import { useTranslation } from "react-i18next";
import { Text } from "components/text";
import { useOrganisations } from "contexts/OrganisationsProvider";
import { OrganisationsTable } from "./components/OrganisationsTable";
import { AddOrganisationModal } from "./components/AddOrganisationModal";

export const OrganisationsPage = () => {
  const { t } = useTranslation("settings");

  const { organisations } = useOrganisations();

  return (
    <div className="px-28 py-10 space-y-8 overflow-auto">
      <div className="space-y-1">
        <Text as="h1" variant="heading">
          {t("settings:organisations.overview.title")}
        </Text>
        <Text variant="subtle">
          {t("settings:organisations.overview.subtitle.text", {
            count: organisations.length,
          })}
        </Text>
      </div>

      <div className="space-y-4">
        <div className="flex justify-end">
          <AddOrganisationModal />
        </div>

        <OrganisationsTable organisations={organisations} />
      </div>
    </div>
  );
};
